module.exports = __webpack_public_path__ + "static/img/312_TO8_2304_og.994a601.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/312_TO8_2304_og.jpg
// module id = zzQ+
// module chunks = 0